import { StaticQuery, graphql } from 'gatsby';

import Helmet from 'react-helmet';
import React, { useEffect } from 'react';

export const SeoTags = ({
  description,
  lang = 'en',
  meta = [],
  keywords = [],
  title = 'ReshapeMe',
  product,
}) => {
  useEffect(() => {
    if (!product) return;
    // eslint-disable-next-line
    const _learnq = _learnq || [];
    const item = {
      Name: product.title,
      ProductID: product.shopify_product.id,
      Categories: product.title,
      ImageURL: product.shopify_product.image.src,
      URL: `https://shop.reshape.me/products/${product.uid}`,
      Brand: 'ReshapeMe',
      Price: product.shopify_product.variants[0].price,
      CompareAtPrice: product.shopify_product.variants[0].compareAtPrice,
    };
    _learnq.push(['track', 'Viewed Product', item]);
    _learnq.push([
      'trackViewedItem',
      {
        Title: item.Name,
        ItemId: item.ProductID,
        Categories: item.Categories,
        ImageUrl: item.ImageURL,
        Url: item.URL,
        Metadata: {
          Brand: item.Brand,
          Price: item.Price,
          CompareAtPrice: item.CompareAtPrice,
        },
      },
    ]);
  }, [product]);

  return (
    <>
      <StaticQuery
        query={detailsQuery}
        render={data => {
          const metaDescription = description || data.site.siteMetadata.description;
          return (
            <Helmet
              htmlAttributes={{
                lang,
              }}
              title={title}
              titleTemplate={`%s | ${data.site.siteMetadata.title}`}
              meta={[
                {
                  name: `description`,
                  content: metaDescription,
                },
                {
                  property: `og:title`,
                  content: title,
                },
                {
                  property: `og:description`,
                  content: metaDescription,
                },
                {
                  property: `og:type`,
                  content: `website`,
                },
                {
                  name: `twitter:card`,
                  content: `summary`,
                },
                {
                  name: `twitter:creator`,
                  content: data.site.siteMetadata.twitter,
                },
                {
                  name: `twitter:title`,
                  content: title,
                },
                {
                  name: `twitter:description`,
                  content: metaDescription,
                },
              ]
                .concat(
                  keywords.length > 0
                    ? {
                        name: `keywords`,
                        content: keywords.join(`, `),
                      }
                    : [],
                )
                .concat(meta)}
            />
          );
        }}
      />
    </>
  );
};

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        twitter
      }
    }
  }
`;
